import { FormattedMessage } from 'react-intl'
import { useMountEffect } from '@react-hookz/web'

import { CardBody, PrimaryButton } from 'Components/_theme'

import {
  LostOrStolenModalLandingProps,
  LostOrStolenModalStepsEnum,
  LostOrStolenModalTypesEnum,
} from 'Modals/LostOrStolenModal/LostOrStolenModal.types'

import {
  E2E_LOST_STOLEN_REPLACEMENT_DEPOT,
  E2E_LOST_STOLEN_REPLACEMENT_EVERPHONE,
  E2E_LOST_STOLEN_REPLACEMENT_NONE,
} from 'Constants/e2e'

import { ReplacementType } from 'Portal/__generated__/globalTypes'

export const LostOrStolenModalLanding = (
  props: LostOrStolenModalLandingProps,
) => {
  const {
    type,
    isNoReplacementEnabled,
    isReplacementDeviceAvailableInDepot,
    onSetCurrentStep,
    onSetSelectionType,
    onSetShippingFormData,
  } = props

  const handleGoToReplacementForm = () => {
    if (!isReplacementDeviceAvailableInDepot) {
      return
    }

    onSetSelectionType(ReplacementType.depot)
    onSetCurrentStep(LostOrStolenModalStepsEnum.REPLACEMENT_FORM)
  }

  const handleGoToShippingForm = () => {
    onSetSelectionType(ReplacementType.everphone)
    onSetCurrentStep(LostOrStolenModalStepsEnum.SHIPPING_FORM)
  }

  const handleGoToSummary = () => {
    onSetSelectionType(ReplacementType.none)
    onSetCurrentStep(LostOrStolenModalStepsEnum.SUMMARY)
  }

  useMountEffect(() => {
    onSetShippingFormData(null)
  })

  return (
    <CardBody>
      {type === LostOrStolenModalTypesEnum.ORGANISATION_WITH_DEPOT && (
        <>
          <PrimaryButton
            className="w-100"
            data-e2e={E2E_LOST_STOLEN_REPLACEMENT_DEPOT}
            disabled={!isReplacementDeviceAvailableInDepot}
            onClick={handleGoToReplacementForm}
          >
            <FormattedMessage id="LostOrStolenModal_orderDepot" />
          </PrimaryButton>

          {!isReplacementDeviceAvailableInDepot && (
            <small className="d-block mt-1">
              <FormattedMessage id="LostOrStolenModal_noReplacementFound" />
            </small>
          )}
        </>
      )}

      <PrimaryButton
        className="w-100 mt-4"
        data-e2e={E2E_LOST_STOLEN_REPLACEMENT_EVERPHONE}
        onClick={handleGoToShippingForm}
      >
        <FormattedMessage id="LostOrStolenModal_orderEverphone" /> *
      </PrimaryButton>

      {isNoReplacementEnabled && (
        <PrimaryButton
          className="w-100 mt-4"
          data-e2e={E2E_LOST_STOLEN_REPLACEMENT_NONE}
          onClick={handleGoToSummary}
        >
          <FormattedMessage id="LostOrStolenModal_noReplacement" />
        </PrimaryButton>
      )}

      <small className="d-block mt-4">
        <FormattedMessage id="LostOrStolenModal_replacementModelNote" />
      </small>
    </CardBody>
  )
}
